import React, { useState } from 'react';
import SourceBadge from './SourceBadge';
import './RAGAnalysis.css';

const RAGRemediationSection = ({ remediation, source }) => {
    const [expanded, setExpanded] = useState(false);

    if (!remediation || typeof remediation !== 'object') return null;

    const immediate = Array.isArray(remediation.immediate) ? remediation.immediate : [];
    const codeFix = Array.isArray(remediation.permanent_fix || remediation.code_fix)
        ? (remediation.permanent_fix || remediation.code_fix)
        : [];
    const infrastructure = Array.isArray(remediation.infrastructure) ? remediation.infrastructure : [];
    const verification = Array.isArray(remediation.verification) ? remediation.verification : [];
    const monitoring = Array.isArray(remediation.monitoring) ? remediation.monitoring : [];
    const checklist = Array.isArray(remediation.checklist) ? remediation.checklist : [];

    const hasContent = immediate.length > 0 || codeFix.length > 0 || infrastructure.length > 0
        || verification.length > 0 || monitoring.length > 0 || checklist.length > 0;

    if (!hasContent) return null;

    return (
        <div className="rag-section remediation-section">
            <div className="rag-section-header">
                <h4 className="rag-section-title">Remediation Plan</h4>
                <div className="rag-header-actions">
                    <SourceBadge source={source} />
                    <button
                        className="rag-expand-btn"
                        onClick={() => setExpanded(!expanded)}
                        title={expanded ? 'Collapse' : 'Expand details'}
                    >
                        {expanded ? '−' : '+'}
                    </button>
                </div>
            </div>

            {/* Always show immediate actions */}
            {immediate.length > 0 && (
                <div className="remed-group">
                    <h5 className="remed-group-label remed-immediate">Immediate</h5>
                    <ul className="remed-list">
                        {immediate.map((item, i) => <li key={i}>{item}</li>)}
                    </ul>
                </div>
            )}

            {/* Show checklist as a compact default when collapsed */}
            {!expanded && checklist.length > 0 && (
                <div className="remed-group">
                    <h5 className="remed-group-label">Checklist</h5>
                    <ul className="remed-checklist">
                        {checklist.map((item, i) => (
                            <li key={i}><span className="check-icon">[ ]</span> {item}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Expanded detail sections */}
            {expanded && (
                <>
                    {codeFix.length > 0 && (
                        <div className="remed-group">
                            <h5 className="remed-group-label remed-codefix">Code Fix</h5>
                            <ul className="remed-list">
                                {codeFix.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                    {infrastructure.length > 0 && (
                        <div className="remed-group">
                            <h5 className="remed-group-label remed-infra">Infrastructure</h5>
                            <ul className="remed-list">
                                {infrastructure.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                    {monitoring.length > 0 && (
                        <div className="remed-group">
                            <h5 className="remed-group-label">Monitoring</h5>
                            <ul className="remed-list">
                                {monitoring.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                    {verification.length > 0 && (
                        <div className="remed-group">
                            <h5 className="remed-group-label remed-verify">Verification</h5>
                            <ul className="remed-list">
                                {verification.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    )}
                    {checklist.length > 0 && (
                        <div className="remed-group">
                            <h5 className="remed-group-label">Checklist</h5>
                            <ul className="remed-checklist">
                                {checklist.map((item, i) => (
                                    <li key={i}><span className="check-icon">[ ]</span> {item}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {remediation.security_references && (
                        <div className="remed-group">
                            <h5 className="remed-group-label">References</h5>
                            <div className="remed-refs">
                                {remediation.security_references.owasp_top_10 && (
                                    <span className="ref-chip">OWASP: {remediation.security_references.owasp_top_10}</span>
                                )}
                                {remediation.security_references.cwe && (
                                    <a
                                        className="ref-chip ref-link"
                                        href={remediation.security_references.cwe_reference || '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {remediation.security_references.cwe}
                                    </a>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default RAGRemediationSection;
